/**
 * This file is a part of the Promvc framework.
 * 
 * (c) ThemePlexi
 * 
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import $ from 'jquery';

import {
	NAME as mainName,
	Promvc
} from 'Shared/util/modules';
import ThemeSwitch from './helpers/theme-switch.js';
// import * as serviceWorker from 'Workers/service';

import 'Scss/bootstrap-4/common.scss';

/**
 * Declare private properties
 * @private
 */

const DATA_KEY = 'promvc.common';

let initialised = false;

/**
 * The client-side home app.
 * 
 * @since 1.0.0
 */
class CommonApp
{
	constructor( element )
	{
		// Containers
		this._root = element;

		// Components
		this._forms = [].slice.call( document.getElementsByClassName( 'needs-validation' ) );
	}

	/**
	 * Initialise.
	 * 
	 * @access public
	 * @return {void}
	 */
	init()
	{
		if ( initialised ) return;

		// Handle UI theme switching
		ThemeSwitch._jQueryInterface( this._root, 'init' );

		// register globals
		this.registerGlobals();

		// register init
		initialised = true;
	}

	/**
	 * Register globals.
	 * 
	 * @access public
	 * @return {void}
	 */
	registerGlobals()
	{
		// Add validate methods
		// Promvc.prototype.rules = rules;
		// Promvc.prototype.valid = valid;
		// Promvc.prototype.validate = validate;

		window[ mainName ] = new Promvc();
	}

	// static

	static _jQueryInterface( config )
	{
		return this.each( function () {
			let data = $( this ).data( DATA_KEY );

			if ( ! data ) {
				data = new CommonApp( this );
				$( this ).data( DATA_KEY, data );
			}

			if ( typeof config === 'string' )
			{
				if ( typeof data[ config ] === 'undefined' ) {
					throw new TypeError( `No method named "${config}"` );
				}

				data[ config ]();
			}
		});
	}
}

/**
 * Load application.
 */

// Register app
$( function () {

	$( 'body' ).each( function () {
		const $wrapper = $( this );
		CommonApp._jQueryInterface.call( $wrapper, 'init' );
	});

});

// register service worker
// serviceWorker.register( serviceWorker.config );